import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const searchUsers = (query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/search`, { params: query });

export const getUserInfoUnitTest = (email: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/unit-test/${email}`);

export const updateUserInfo = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/update`, params);

export const resetPasswordUser = (id: string, query: any = {}) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/reset-password/${id}`, query)

export const revertPasswordUser = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/revert-password/${id}`);

export const removeUserMFA = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/remove-mfa/${id}`);

export const resetUserLoginSecurity = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/reset-login-security/${id}`);

export const resetMemberLoginSecurity = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/member/reset-login-security/${id}`);

export const getUserLoginSecurityStatus = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/login-security-status/${id}`)

export const logoutUserFromServices = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/azinsight/logout`, params)

export const extendTrialAZ = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/azinsight/extend-trial`, params)

export const updateStatusMember = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/member/status-update`, params)

export const addMember = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/add-member`, params)

export const removeMember = (email: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/remove-member`, { email })

export const removeAccount = (contactId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/remove-account`, { contactId })

export const deletePlugin = (pluginId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/users/plugin/${pluginId}/delete`)

export const deletePlan = (planId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/users/plan/${planId}/delete`)

export const deleteProductType = (userId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/users/product-type/delete/${userId}`)

export const deleteSpToken = (userId: string, region: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/users/sp-token/${region}/delete/${userId}`)

export const deleteSellerId = (userId: string, region: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/users/seller-id/${region}/delete/${userId}`)

export const getLatestStripePayments = (contactId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/stripe/${contactId}/get-latest-list`)

export const syncMarketplaceConnectionsFromPortal = (userId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/marketplace-connections/sync-from-portal`)

export const getUserSpToken = (userId: string, region: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/${userId}/sp-token/${region}`)

/** Server-side copy of AZInsight SP token into CommandHub for one region. Tokens are not returned. */
export const copyAzinsightSpTokenToCommandHub = (userId: string, region: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/commandhub/sp-token/from-azinsight`, { region })

export const addSpToken = (userId: string, region: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/sp-token/${region}/add`, payload)

export const addSellerId = (userId: string, region: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/seller-id/${region}/add`, payload)

// Stale Accounts APIs
export const getStaleAccountsCount = (params?: { filter18Month?: string; accountType?: string }) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/stale-accounts/count`, { params })

export const getStaleAccounts = (params: { limit?: number; offset?: number; search?: string; accountType?: string; filter18Month?: string }) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/stale-accounts`, { params })

export const blockStaleAccounts = (userIds: string[]) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/stale-accounts/block`, { userIds })

export const unblockStaleAccounts = (userIds: string[]) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/stale-accounts/unblock`, { userIds })

export const delete18MonthIdleAccounts = (userIds: string[] | null) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/stale-accounts/delete-18-month-idle`, { userIds: userIds ?? [] })

// Audit Logs API
export const getAuditLogs = (params: { limit?: number; offset?: number; search?: string; action?: string }) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/audit-logs`, { params })

export const getWalmartTokenStatus = (userId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/${userId}/walmart-token/status`)

export const refreshWalmartToken = (userId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/walmart-token/refresh`)

export const addWalmartToken = (userId: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/walmart-token/add`, payload)

export const addCommandHubSpToken = (userId: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/commandhub/sp-token`, payload)

export const getCommandHubConnection = (userId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/${userId}/commandhub/connection`)

export const testCommandHubSpApi = (userId: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/commandhub/sp-api/test`, payload)

export const syncWalmartRecommendations = (userId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/walmart/recommendations/sync`, {})

export const testWalmartNotification = (userId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/walmart/notification/test`, {})

export const testWalmartApi = (userId: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/${userId}/walmart/test`, payload)